import React, { useRef } from "react";
import LabelContainer from "../LabelContainer";
import EmptyButton from "./EmptyButton";

const ColorInput = ({
  k = -1,
  autoFocus,
  autocomplete = "on",
  inputStyle = {},
  inputClassName = "",
  type,
  disabled = false,
  id = null,
  value,
  change = () => {},
  placeholder = "#xxxxxx",
  ...props
}) => {
  const inputRef = useRef(null);
  const valueChange = (e) => {
    let filteredValue = e.target.value;

    let changeEvent = {
      target: {
        name: props.name,
        value: filteredValue,
        k: k,
      },
    };

    change(changeEvent);
  };
  return (
    <LabelContainer {...props} value={value}>
      <input
        ref={inputRef}
        autoFocus={autoFocus}
        autoComplete={autocomplete}
        style={{ ...inputStyle, width: "60%" }}
        className={"form-control " + inputClassName}
        type="color"
        disabled={disabled ? "disabled" : false}
        id={k != -1 ? props.name + "-" + k : id ? id : props.name}
        name={props.name}
        value={value}
        onChange={valueChange}
        placeholder={placeholder}
      />
      <input
        ref={inputRef}
        autoFocus={autoFocus}
        autoComplete={autocomplete}
        style={inputStyle}
        className={"form-control " + inputClassName}
        type="text"
        disabled={disabled ? "disabled" : false}
        id={k != -1 ? props.name + "-" + k : id ? id : props.name}
        name={props.name}
        value={value}
        onChange={valueChange}
        placeholder={placeholder}
      />

      {!disabled && (
        <EmptyButton
          change={change}
          name={props.name}
          targetInput={inputRef}
          value={value}
        />
      )}
    </LabelContainer>
  );
};

export default ColorInput;
